<template>
  <v-row align="center" justify="center">
    <v-col cols="12" xl="10" lg="10">
      <v-row v-editable="blok" class="grid" align="center" justify="center">
        <component
          :key="blok._uid"
          v-for="blok in blok.columns"
          :blok="blok"
          :is="blok.component"
        ></component>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["blok"]
};
</script>
